module.exports = __webpack_public_path__ + "img/left_right_layout_3.07891788.png";